import { Box, Step, StepLabel, Stepper } from "@mui/material";
import { useTranslations } from "next-intl";
import { getStepKeys } from "./steps";

interface PatientDetailsStepperProps {
  activeStep: number;
  registrationType?: string;
}

export const PatientDetailsStepper = ({
  activeStep,
  registrationType,
}: PatientDetailsStepperProps) => {
  const t = useTranslations("onboardingV2");
  const stepKeys = getStepKeys(registrationType);
  return (
    <Box
      sx={(theme) => ({
        width: "100%",
        flex: 1,
        paddingY: 3,
        paddingX: { xs: 4, md: 12, lg: 48 },
        border: "1px solid",
        borderColor: theme.vars!.palette.rmh.border["1-surface"].rest,
        backgroundColor: theme.vars!.palette.rmh.paper["1-surface"].rest,
      })}
    >
      <Stepper activeStep={activeStep}>
        {stepKeys.map((key) => (
          <Step key={key}>
            <StepLabel>{t(`steps.${key}`)}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};
